/**
 * Complete your set — ticks, per-product variant resolution, one add.
 *
 * Everything ticked goes to /cart/add.js in a single request. Shopify accepts
 * an `items` array, so this is one round trip and one cart-updated event
 * rather than a burst of them, which matters because the drawer re-renders on
 * each one.
 *
 * Each product resolves its own variant from its own selects, so a product with
 * a finish and a size still contributes exactly one id. A tile whose selection
 * has no matching variant is skipped rather than sent - the server would reject
 * the whole batch and nothing would be added, including the items that were
 * fine.
 */
(function () {
  /* Editable wording. Sources: Theme settings > "Text: ..." groups,
     serialised by snippets/calmy-strings.liquid. The second argument is
     the wording this file shipped with and is used when the snippet is
     absent or the setting is blank. */
  var CT = function (k, f) { return window.CalmyT ? window.CalmyT(k, f) : f; };

  "use strict";

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2);
    if (!fmt) return "$" + v;
    return fmt.replace(/\{\{\s*amount\s*\}\}/, v)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace(".", ","));
  }

  function init(root) {
    if (root.__calmyXs) return;
    root.__calmyXs = true;

    var items = [].slice.call(root.querySelectorAll(".cxs__item"));
    var btn = root.querySelector("[data-calmy-xs-add]");
    var err = root.querySelector("[data-calmy-xs-err]");
    if (!items.length || !btn) return;

    var fmt = btn.getAttribute("data-money-format") || "";
    var base = btn.getAttribute("data-label") || "Add selected";

    function variantFor(item) {
      var pick = item.querySelector("[data-calmy-xs-pick]");
      var json = item.querySelector("[data-calmy-xs-variants]");
      /* No options to resolve: the one variant's figures are on the tick
         itself. `compare` has to travel with them, or a product with nothing
         to choose loses the struck price the moment this repaints. */
      if (!json) {
        return {
          id: pick.getAttribute("data-variant"),
          price: +pick.getAttribute("data-price"),
          compare: +pick.getAttribute("data-compare") || 0
        };
      }

      var list;
      try { list = JSON.parse(json.textContent); } catch (e) { return null; }
      var chosen = [];
      item.querySelectorAll("[data-calmy-xs-opt]").forEach(function (sel) {
        chosen[+sel.getAttribute("data-calmy-xs-opt")] = sel.value;
      });
      var v = list.filter(function (x) {
        for (var i = 0; i < chosen.length; i++) if (chosen[i] && x.options[i] !== chosen[i]) return false;
        return true;
      })[0];
      return v && v.available ? { id: v.id, price: v.price, compare: v.compare || 0 } : null;
    }

    /* THE TILE'S OWN TWO FIGURES, from whichever variant the selects resolve
       to - the same one the button would add. Both move together or neither
       moves: a compare-at left over from the previous selection would be a
       discount against a price nobody is charging. A selection with no
       matching variant leaves the last good pair on screen, because the tile
       already reports that state through the button and the error line. */
    function paint(item) {
      var now = item.querySelector("[data-calmy-xs-now]");
      var was = item.querySelector("[data-calmy-xs-was]");
      if (!now) return;
      var pick = item.querySelector("[data-calmy-xs-pick]");
      var v = variantFor(item);
      if (!v) return;
      now.textContent = money(v.price, fmt);
      if (!was) return;
      if (v.compare > v.price) {
        was.textContent = money(v.compare, fmt);
        was.hidden = false;
      } else {
        was.textContent = "";
        was.hidden = true;
      }
      if (pick) {
        pick.setAttribute("data-price", v.price);
        pick.setAttribute("data-compare", v.compare || 0);
      }
    }

    function sync() {
      var total = 0, n = 0;
      items.forEach(function (item) {
        paint(item);
        var pick = item.querySelector("[data-calmy-xs-pick]");
        if (!pick || !pick.checked) return;
        var v = variantFor(item);
        if (!v) return;
        total += v.price;
        n += 1;
      });
      btn.disabled = n === 0;
      btn.textContent = n === 0 ? base : base + " · " + money(total, fmt);
    }

    root.addEventListener("change", function (e) {
      if (e.target.matches("[data-calmy-xs-pick], [data-calmy-xs-opt]")) sync();
    });

    btn.addEventListener("click", function () {
      var payload = [];
      var unavailable = 0;
      items.forEach(function (item) {
        var pick = item.querySelector("[data-calmy-xs-pick]");
        if (!pick || !pick.checked) return;
        var v = variantFor(item);
        if (!v) { unavailable += 1; return; }
        payload.push({ id: v.id, quantity: 1 });
      });
      if (!payload.length) {
        if (err) { err.textContent = CT("xs_combo_unavailable", "That combination is not available."); err.classList.add("is-on"); }
        return;
      }
      if (err) { err.textContent = ""; err.classList.remove("is-on"); }

      btn.disabled = true;
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + "cart/add.js" : "/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: payload }),
      })
        .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
        .then(function () {
          btn.textContent = btn.getAttribute("data-label-added") || "Added";
          items.forEach(function (item) {
            var pick = item.querySelector("[data-calmy-xs-pick]");
            if (pick) pick.checked = false;
          });
          /* Re-render the drawer.

             Dispatching cart:refresh / cart:updated did nothing - this theme's
             drawer has no listener for either, it exposes Calmy.refreshCart and
             every other add path calls it directly. Without this the customer
             pressed Add, the request succeeded, and the drawer went on showing
             the old subtotal and line items.

             Opened afterwards only when the panel is not already the thing
             being used; from inside the drawer, re-opening would fight it. */
          if (window.Calmy && window.Calmy.refreshCart) {
            var inDrawer = !!root.closest("[data-calmy-cart]");
            window.Calmy.refreshCart(!inDrawer);
          }
          setTimeout(sync, 1400);
        })
        .catch(function () {
          btn.disabled = false;
          if (err) {
            err.textContent = unavailable
              ? CT("xs_some_unavailable", "Some of those are unavailable right now.")
              : CT("xs_add_failed", "Could not add those. Please try again.");
            err.classList.add("is-on");
          }
        });
    });

    sync();
  }

  function boot() { document.querySelectorAll("[data-calmy-xs]").forEach(init); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  document.addEventListener("shopify:section:load", function (e) {
    e.target.querySelectorAll("[data-calmy-xs]").forEach(init);
  });
})();
